/**
 * Statuspage.io components
 */
import _ from 'underscore';
import Backbone from 'backbone';
import incident_levels from '@/mixins/incident_levels';

    var components_collection = new Backbone.Collection();
    _.extend(components_collection, {
        url: 'https://electricimp.statuspage.io/api/v2/components.json',
        parse: function(resp) {
            return _(resp.components).filter(function(item) {
                return item.name !== 'IDE';
            });
        },
        fetch: function(options) {
            if (!options) options = {};
            var existingSuccessCallback = options.success;
            options.success = function(collection, response, options) {
                if (existingSuccessCallback) {
                    existingSuccessCallback.call(this, collection, response, options);
                }
            };
            Backbone.Collection.prototype.fetch.call(this, options);
        },
        // constants for using in the app
        NAMES: {
            development : 'Developer Imp Servers',
            production  : 'Production Imp Servers',
            ide         : 'IDE'
        },
        INCIDENT_LEVELS: {
            'operational'           : incident_levels.values.none,
            'degraded_performance'  : incident_levels.values.moderate,
            'partial_outage'        : incident_levels.values.moderate,
            'major_outage'          : incident_levels.values.severe
        },
        type: 'component'
    });

    export default components_collection;

